// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient-title[data-v-732dd0ac]{background:linear-gradient(90deg,#0e3b2f,#2fa66b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
